import { ApiConfig } from "common/models";
import { CONTROLLER } from "common/config/endpoint.config";
import { buildGdxApiUrl } from "common/utils/api.util";

export const documentTypeConfigConfig = {
  getAllDocumentTypeConfigurations: (): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(`${CONTROLLER.GDX_DATABASE}/config/get-all`),
      "GET",
      "",
      undefined
    );
  },

  getDocumentTypeInformation: (documentType: string): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(
        `${CONTROLLER.GDX_DATABASE}/document_type_information/get/${documentType}`
      ),
      "GET",
      "",
      undefined
    );
  }
};
